import React from 'react';

import HubSportScriptLoader from './HubSportScriptLoader';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { UserType } from 'store/modules/auth/auth';
import env from 'consts/env';

interface HubSpotProps {
  user: UserType;
}

const { connect, selectors } = StoreProvider;

const HubSpot = ({ user }: HubSpotProps) => {
  if (env.IS_PRODUCTION) {
    return <HubSportScriptLoader userData={user} />;
  }
  return null;
};

export default connect((state) => ({
  user: selectors.authSelectors.userProfile(state),
}))(HubSpot);
